var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.76,
    height: 33.76,
    viewBox: "0 0 33.069 40.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-text",
    d: "M20.209,0a1.852,1.852,0,0,1,.231.015H20.5a.673.673,0,0,1,.171.035l.055.017a1.687,1.687,0,0,1,.167.057l.053.029a1.666,1.666,0,0,1,.151.073l.057.033a1.788,1.788,0,0,1,.149.1,1.837,1.837,0,0,1,.209.184L21.337.388,21.359.4l.151.134L32.533,11.561a1.85,1.85,0,0,1,.151.171l.029.039a1.776,1.776,0,0,1,.1.149l.033.059a1.428,1.428,0,0,1,.073.151l.02.05a1.671,1.671,0,0,1,.059.167l.015.055a1.643,1.643,0,0,1,.035.171,1.864,1.864,0,0,1,.022.288l-.015-.231v.017l.015.215V34.906a5.512,5.512,0,0,1-5.512,5.512H5.512A5.512,5.512,0,0,1,0,34.906H0V5.512A5.512,5.512,0,0,1,5.512,0ZM18.372,3.674H5.512A1.837,1.837,0,0,0,3.674,5.512h0V34.906a1.837,1.837,0,0,0,1.837,1.837H27.558a1.837,1.837,0,0,0,1.837-1.837h0V14.7H20.209a1.837,1.837,0,0,1-1.824-1.622l-.013-.215Zm5.512,23.883a1.837,1.837,0,0,1,.215,3.662l-.215.013H9.186a1.837,1.837,0,0,1-.215-3.662l.215-.013Zm0-7.349A1.837,1.837,0,0,1,24.1,23.87l-.215.013H9.186a1.837,1.837,0,0,1-.215-3.662l.215-.013ZM12.86,12.86a1.837,1.837,0,0,1,.215,3.661l-.215.013H9.186a1.837,1.837,0,0,1-.215-3.662l.215-.013Zm9.186-6.586v4.749H26.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.33d648fcc0bea9555b61bcc965efa7d2.svg";
export { ForwardRef as ReactComponent };